import React, { useState } from "react";
import EmployeeProcessService from "../services/EmployeeProcessService";

const EmployeeUserLogin = () => {

    const [employeeCode, setEmployeeCode] = useState("");
    const [employeeData, setEmployeeData] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {

        if (!employeeCode.trim()) {
            alert("Please enter Employee Code");
            return;
        }

        try {

            setLoading(true);
            setEmployeeData(null);

            const fd = new FormData();
            fd.append("EmployeeCode", employeeCode.trim());
            fd.append("CreatedBy", "107086");

            const res = await EmployeeProcessService.getEmployeePassword(fd);

            const result = res?.data?.result;

            if (result && result.length > 0) {
                setEmployeeData(result[0]);
            } else {
                alert("No employee data found");
            }

        } catch (error) {

            console.error(error);
            alert("Something went wrong while searching employee");

        } finally {
            setLoading(false);
        }
    };


    const handleReset = () => {
        setEmployeeCode("");
        setEmployeeData(null);
    };


    return (

        <div className="container mt-4">

            <h3 className="mb-3">Employee User Login</h3>

            <div className="card p-4 mb-4">

                <div className="row g-3 align-items-end">

                    <div className="col-md-4">

                        <label className="form-label">
                            Employee Code
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Employee Code"
                            value={employeeCode}
                            onChange={(e) => setEmployeeCode(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleSearch();
                                }
                            }}
                        />

                    </div>

                    <div className="col-md-2">

                        <button
                            className="btn btn-primary me-2"
                            onClick={handleSearch}
                            disabled={loading}
                        >
                            {loading ? "Searching..." : "Search"}
                        </button>

                        <button
                            className="btn btn-secondary"
                            onClick={handleReset}
                        >
                            Reset
                        </button>

                    </div>

                </div>

            </div>


            {/* Employee Details */}

            {employeeData && (

                <div className="card">

                    <div className="card-header bg-dark text-white">
                        Employee Login Details
                    </div>

                    <div className="card-body">

                        <div className="row g-3">

                            <div className="col-md-4">

                                <label className="form-label">
                                    Employee Code
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={employeeData.employeeCode || ""}
                                    readOnly
                                />

                            </div>


                            <div className="col-md-4">

                                <label className="form-label">
                                    Employee Name
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={employeeData.employeeName || ""}
                                    readOnly
                                />

                            </div>


                            <div className="col-md-4">

                                <label className="form-label">
                                    Password
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={employeeData.password || ""}
                                    readOnly
                                />

                            </div>


                            <div className="col-md-4">

                                <label className="form-label">
                                    Status
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={employeeData.status || ""}
                                    readOnly
                                />

                            </div>

                        </div>

                    </div>

                </div>

            )}

        </div>
    );
};

export default EmployeeUserLogin;